@if (allBlocks().length > 0) {

<!-- Silent blocks: tool_frontend auto-executors (invisible unless debug mode) -->
@for (block of silentBlocks(); track block.id) {
<app-tool-frontend-executor [data]="asToolFrontendData(block)" [status]="block.status" />
}

<!-- Hint chips: geolocation/place + plan workarea, inline row above the cards -->
@if (geoHintBlocks().length > 0 || workareaHintBlocks().length > 0) {
<div class="d-flex flex-wrap gap-2 mt-2">
  @for (block of geoHintBlocks(); track block.id) {
    <app-geo-hint-chip [data]="asContentBlockData(block)" />
  }
  @for (block of workareaHintBlocks(); track block.id) {
    <app-workarea-hint-chip [data]="asContentBlockData(block)" />
  }
</div>
}

<!-- Grid blocks: plan/job cards first, then evidence results (1 / 2 / 3 cols by breakpoint) -->
@if (gridBlocks().length > 0) {
<app-card-grid class="mt-2">
  @for (block of gridBlocks(); track block.id) { @switch (block.kind) { @case ('api_endpoint') {
  <app-endpoint-card [data]="asApiEndpointData(block)" [status]="block.status" />
  } @case ('background_job') {
  <app-task-list-card class="task-card-full-width" [block]="asBackgroundJobData(block)" />
  } @case ('plan') {
  <app-plan-card class="task-card-full-width" [data]="asPlanData(block)" [status]="block.status" />
  } @case ('map_layer') {
  <app-map-layer-card [data]="asContentBlockData(block)" [status]="block.status" />
  } @default {
  <app-content-block-card [kind]="block.kind" [data]="asContentBlockData(block)" [blockId]="block.id" />
  } } }
</app-card-grid>
@for (block of gridBlocks(); track block.id) {
  @if (block.kind === 'background_job') {
    <app-deep-analysis-message class="d-block mt-2" [block]="asBackgroundJobData(block)" />
  }
}
}
}
